import React from 'react'

const SvgComponent = props => (
  <svg width={67} height={67} {...props}>
    <defs>
      <linearGradient
        x1="7.569%"
        y1="110.903%"
        x2="78.899%"
        y2="7.982%"
        id="go__prefix__a"
      >
        <stop stopColor="#FAC9E3" stopOpacity={0.4} offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <path
        d="M23.745 46.49c12.837 0 23.244-10.408 23.244-23.245 0-4.133-1.078-8.014-2.97-11.377C40.038 4.785 32.45 0 23.746 0 10.907 0 .5 10.407.5 23.245c0 12.837 10.407 23.244 23.245 23.244z"
        id="go__prefix__b"
      />
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="go__prefix__d"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="155.653%"
        y1="90.79%"
        x2="-78.638%"
        y2="-43.889%"
        id="go__prefix__e"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="219.481%"
        y1="50%"
        x2="-105.155%"
        y2="73.949%"
        id="go__prefix__f"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="35.267%"
        y2="50%"
        id="go__prefix__g"
      >
        <stop stopColor="#F57B94" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-92.882%"
        y1="87.838%"
        x2="0%"
        y2="87.838%"
        id="go__prefix__h"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        fill="url(#go__prefix__a)"
        opacity={0.166}
        cx={33.602}
        cy={33.159}
        r={33}
      />
      <g transform="translate(10 11)">
        <mask id="go__prefix__c" fill="#fff">
          <use xlinkHref="#go__prefix__b" />
        </mask>
        <g mask="url(#go__prefix__c)">
          <path
            d="M40.396 11.867c0 2.039-1.633 3.692-3.647 3.692s-3.647-1.653-3.647-3.692 1.633-3.691 3.647-3.691 3.647 1.652 3.647 3.691z"
            fill="#E98699"
          />
          <path
            d="M38.28 11.869c0 .855-.686 1.549-1.531 1.549a1.541 1.541 0 0 1-1.531-1.55c0-.855.686-1.549 1.53-1.549.846 0 1.532.694 1.532 1.55z"
            fill="#5D3511"
          />
          <path
            d="M15.637 11.867c0 2.039-1.633 3.69-3.647 3.69s-3.647-1.651-3.647-3.69c0-2.038 1.633-3.69 3.647-3.69s3.647 1.652 3.647 3.69z"
            fill="#E98699"
          />
          <path
            d="M13.52 11.869c0 .855-.686 1.549-1.531 1.549a1.541 1.541 0 0 1-1.531-1.55c0-.855.686-1.549 1.53-1.549.846 0 1.532.694 1.532 1.55z"
            fill="#5D3511"
          />
          <path
            d="M3.582 15.143v-.122C3.582 6.85 10.19.161 18.267.161c8.077 0 14.684 6.688 14.684 14.86v25.464L18.266 49.04 3.582 40.459V15.143z"
            fill="url(#go__prefix__d)"
            transform="translate(6.05 5.832)"
          />
          <path
            d="M22.38 17c0 2.833-2.27 5.13-5.07 5.13-2.8 0-5.07-2.297-5.07-5.13 0-2.835 2.27-5.131 5.07-5.131 2.8 0 5.07 2.296 5.07 5.13zM36.75 17c0 2.833-2.27 5.13-5.07 5.13-2.801 0-5.07-2.297-5.07-5.13 0-2.835 2.269-5.131 5.07-5.131 2.8 0 5.07 2.296 5.07 5.13zM24.32 28.901a.929.929 0 0 1-.923.935.929.929 0 0 1-.923-.935c0-.516.413-.934.923-.934s.923.418.923.934z"
            fill="#FFF"
          />
          <path
            fill="#FFF"
            d="M22.472 28.902h1.848v-2.965h-1.848zM25.692 27.967c.51 0 .923.418.923.934a.929.929 0 0 1-.923.935.929.929 0 0 1-.924-.935c0-.516.414-.934.924-.934"
          />
          <path fill="#FFF" d="M24.769 28.902h1.846v-2.965H24.77z" />
          <path
            d="M29.704 15.706c.845 0 1.531.694 1.531 1.55 0 .855-.686 1.549-1.53 1.549a1.541 1.541 0 0 1-1.532-1.55c0-.855.686-1.549 1.531-1.549M16.47 17.256c0 .855-.687 1.549-1.532 1.549a1.54 1.54 0 0 1-1.53-1.55c0-.855.684-1.549 1.53-1.549.845 0 1.532.694 1.532 1.55z"
            fill="#5D3511"
          />
          <path
            d="M34.873 25.383h-3.41v-3.065h3.409c.837 0 1.514.686 1.514 1.531 0 .847-.677 1.534-1.513 1.534z"
            fill="url(#go__prefix__e)"
            transform="translate(6.05 5.832)"
          />
          <path
            d="M1.66 25.383a1.524 1.524 0 0 1-1.514-1.534 1.523 1.523 0 0 1 1.548-1.531H5.07v3.065H1.66z"
            fill="url(#go__prefix__f)"
            transform="translate(6.05 5.832)"
          />
          <path
            d="M22.894 19.383c0 .844-.678 1.527-1.518 1.527a1.522 1.522 0 0 1-1.518-1.527c0-.842.679-1.525 1.518-1.525.84 0 1.518.683 1.518 1.525z"
            fill="url(#go__prefix__g)"
            transform="translate(6.05 5.832)"
          />
          <path
            d="M15.682 17.858c.84 0 1.52.683 1.52 1.525 0 .844-.68 1.527-1.52 1.527a1.523 1.523 0 0 1-1.518-1.527c0-.842.68-1.525 1.518-1.525"
            fill="url(#go__prefix__h)"
            transform="translate(6.05 5.832)"
          />
          <path
            d="M22.382 26.594c1.052-.657 2.71-1.093 4.116-.173 1.404.92 1.894-2.376 1.894-2.376-1.648-1.044-4.821-1.525-7.498-.102l1.488 2.651z"
            fill="#E03E5E"
          />
          <path
            d="M24.61 21.698c1.247 0 2.257.608 2.257 1.358 0 .75-1.01 1.357-2.257 1.357-1.248 0-2.258-.607-2.258-1.357s1.01-1.358 2.258-1.358"
            fill="#5D3511"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default SvgComponent
